import React from 'react'
import Aos from 'aos'
import SBKS1 from '../../Images/HR/SaabikkaSantha/LateKrishnaPrasadDahal.JPG'
import SBKS2 from '../../Images/HR/SaabikkaSantha/ArjunRajAdhikari.JPG'
import SBKS3 from '../../Images/HR/SaabikkaSantha/BhaktiPrasadDhakal.jpg'
import SBKS4 from '../../Images/HR/SaabikkaSantha/BalaramPokhrel.jpg'
import SBKS5 from '../../Images/HR/SaabikkaSantha/FadindraPoudel.jpg'
import SBKS6 from '../../Images/HR/SaabikkaSantha/UmeshUpreti.jpg'
import SBKS7 from '../../Images/HR/SaabikkaSantha/RabindraKrishnaShrestha.jpg'
import SBKS8 from '../../Images/HR/SaabikkaSantha/JhamkBahadurKarki.jpeg'
import SBKS9 from '../../Images/HR/SaabikkaSantha/LaxmiPrasadGhimire.jpg'

const SabikkaSantha = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    });

    const saabikSanthaList = [
        {
            id: '1',
            memName: 'स्व. कृष्णप्रसाद दाहाल',
            post: 'अध्यक्ष',
            memImg: SBKS1,
            office: 'सुन्दरपुर साकोस'
        },
        {
            id: '2',
            memName: 'अर्जुनराज अधिकारी',
            post: 'अध्यक्ष',
            memImg: SBKS2,
            office: 'गछिया साकोस'
        },
        {
            id: '3',
            memName: 'भक्तिप्रसाद ढकाल',
            post: 'अध्यक्ष',
            memImg: SBKS3,
            office: 'गुराँस साकोस'
        },
        {
            id: '4',
            memName: 'बलराम पोखरेल',
            post: 'अध्यक्ष',
            memImg: SBKS4,
            office: 'शुभलक्ष्मी साकोस'
        },
        {
            id: '5',
            memName: 'फडिन्द्र पौडेल',
            post: 'अध्यक्ष',
            memImg: SBKS5,
            office: 'न्यू नमूना साकोस'
        },
        {
            id: '6',
            memName: 'उमेश उप्रेती',
            post: 'अध्यक्ष',
            memImg: SBKS6,
            office: 'घरआँगन साकोस'
        },
        {
            id: '7',
            memName: 'रवीन्द्रकृष्ण श्रेष्ठ',
            post: 'अध्यक्ष',
            memImg: SBKS7,
            office: 'पिण्डेश्वरी साकोस'
        },
        {
            id: '8',
            memName: 'झमकबहादुर कार्की',
            post: 'अध्यक्ष',
            memImg: SBKS8,
            office: 'प्रारम्भ साकोस'
        },
        {
            id: '9',
            memName: 'लक्ष्मीप्रसाद घिमिरे',
            post: 'अध्यक्ष',
            memImg: SBKS9,
            office: 'प्रसून साकोस'
        },
    ]

    return (
        <>
            <div className='main'>
                <div className='left-fixed'></div>
                <div className='container'>
                    <div className='heading1' data-aos='fade-right'>
                        <div className='h2'>
                            <h2>साविकका संस्था/अध्यक्ष</h2><hr />
                        </div>
                    </div>
                    <div className='president2' data-aos='fade-right'>
                        {saabikSanthaList.map((item, index) => {
                            return (
                                <div className='president2-body' key={index}>
                                    <div className='president2-img'>
                                        <img src={item.memImg} alt='AccountComittee' />
                                    </div>
                                    <div className='president2-detail'>
                                        <h2>{item.memName}</h2>
                                        <h3>{item.post}</h3>
                                        <h3>{item.office}</h3>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default SabikkaSantha